export default {
    actions: {
        save: 'Salvar',
        edit: 'Editar',
        delete: 'Excluir',
        simulate: 'Simular',
    },

    errors: {
        between: 'O valor do campo {label} deve ser entre {min} e {max}.',
        maxLength: 'O campo {label} deve ter no máximo {length} caracteres.',
        minLength: 'O campo {label} deve ter no mínimo {length} caracteres.',
        minValue: 'O valor do campo {label} deve ser maior ou igual a {min}.',
        required: 'O campo {label} é obrigatório.',
        email: 'O campo {label} deve ser um e-mail válido.',
    },

    title: '{prefix} {resource}',

    title_prefix: {
        add: 'Adicionar',
        edit: 'Editar',
    },

    messages: {
        saved: 'O {resource} {name} foi salvo com sucesso.',
        validationError: 'Preencha o formulário corretamente.',
    },

    placeHolders: {
        typeToSearch: 'Digite para pesquisar',
    },

    loadingOptions: 'Carregando opções...',
    noOptionsFound: 'Nenhuma opção encontrada.',
    selectAll: 'Selecionar todos',
}
